<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-6 col-md-3  ">
        <div class="icon_box_two">
          <i class="ion-ios-calendar-outline"></i>
          <div class="content">
            <h5 class="box_title">
              DATE
            </h5>
            <p>
              13 July 2018
            </p>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-3  ">
        <div class="icon_box_two">
          <i class="ion-ios-location-outline"></i>
          <div class="content">
            <h5 class="box_title">
              location
            </h5>
            <p>
              SUTD, Singapore
            </p>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-3  ">
        <div class="icon_box_two">
          <i class="ion-ios-person-outline"></i>
          <div class="content">
            <h5 class="box_title">
              speakers
            </h5>
            <p>
              International
            </p>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-3  ">
        <div class="icon_box_two">
          <i class="ion-ios-pricetag-outline"></i>
          <div class="content">
            <h5 class="box_title">
              Registration
            </h5>
            <p>
              Free
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OverviewSection',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OverviewSection.vue